import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
